module.exports = __webpack_public_path__ + "img/diversity-inclusion.4a606dfe.jpg";